import FeedCarousel from './FeedCarousel';

export interface IFeedCarouselProps {
  slides: any[];
  SlideComponent: React.ElementType;
};

export default FeedCarousel;
